function readonly<T extends undefined>(input: T): undefined | Readonly<Required<T>>;
function readonly<T>(input: T): Readonly<T>;
function readonly<T>(input: undefined | T): undefined | Readonly<T> {
	return input as undefined | Readonly<T>;
}

export { readonly };
